import { useLogger } from "@bindery/logging/react";
import { useEffect } from "react";
import { useLocation } from "react-router";
import { type AuthActions, browserAuthActions } from "@/auth/actions";
import {
  readerIdOf,
  type SessionStore,
  sessionStore,
  useSession,
} from "@/convex/session";
import { ReadingStats } from "@/library/stats/reading-stats";

export function StatsPage({
  store = sessionStore,
  actions = browserAuthActions,
}: {
  store?: SessionStore;
  actions?: Pick<AuthActions, "manageReader">;
}) {
  const readerId = readerIdOf(useSession(store));
  const { pathname } = useLocation();
  const log = useLogger();

  useEffect(() => {
    if (readerId !== null) log.event("web.page.view", { page: "stats" });
  }, [readerId, log]);

  return (
    <div className="container mx-auto px-4 py-12 md:px-6">
      <h1 className="mb-6 text-3xl font-bold">Your Progress</h1>
      {readerId === null ? (
        <p className="text-muted-foreground">
          Start reading to see your progress here.
        </p>
      ) : (
        <>
          <ReadingStats />
          <p className="mt-8 text-sm">
            <button
              type="button"
              className="bg-transparent p-0 underline"
              onClick={() => actions.manageReader(readerId, pathname)}
            >
              Manage this reader&apos;s account
            </button>
          </p>
        </>
      )}
    </div>
  );
}
